module.exports = __webpack_public_path__ + "static/media/wind-warning.fad434cc.svg";